import { ServiceRequestApi } from "bonusx-api-main-manager";
import { defaultApiConfig } from "../../constants/env";
import axiosInstance from "./axios-config-singleton/axios-config-singleton.instance";

export const serviceRequestLegacyApi = new ServiceRequestApi(defaultApiConfig, undefined, axiosInstance);
